<template>
  <v-dialog v-model="dialog">
    <v-card class="comet-i18n-exclude">
      <v-card-title class="pl-6 pt-6">{{ t('locationPermission.title') }}</v-card-title>
      <v-card-text>
        {{ t('locationPermission.body') }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="$emit('disagree')">
          {{ t('locationPermission.disagree') }}
        </v-btn>
        <v-btn color="primary" @click="$emit('agree')">{{ t('locationPermission.agree') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'LocationPermissionDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['agree', 'disagree', 'close'],
  setup() {
    const { t } = useI18n();
    return { t };
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    close() {
      this.$emit('close');
      this.dialog = false;
    }
  },
  mounted() {
    this.dialog = this.visible;
  },
  watch: {
    visible(visible: boolean) {
      this.dialog = visible;
    }
  }
});
</script>
